import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { RetailReportsErrorHandler } from './retailReportsErrorHandler';

@Injectable()
export class SecurityGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private readonly errorHandler: RetailReportsErrorHandler,
    private readonly router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const client = next.queryParamMap.get('client');
    const country = next.queryParamMap.get('country');

    // Flujo de ingreso externo (ej: www.concesionarios.ford.com)
    // El usuario llega directamente a /documents-search?client=6&country=PER
    // sin pasar por el landing page → CLIENT_SELECTED no está seteado todavía.
    // Guardar los params y redirigir al landing page para que haga el flujo completo.
    if (client && country) {
      this.authService.setTemporalClient({ client, country });
      return this.router.createUrlTree(['/']);
    }

    // Si CLIENT_SELECTED todavía no está seteado (race condition al cargar la app),
    // redirigir al landing page silenciosamente en lugar de mostrar "Acceso Denegado".
    if (!this.authService.getClient()) {
      return this.router.createUrlTree(['/']);
    }

    const asRole = this.authService.asRole(next.data['role']);
    if (!asRole) {
      this.errorHandler.handleError({ status: 401 });
    }

    return asRole;
  }
}
